export var MERGE_CHANGE_KINDS = [
    "MOVE",
    "FOLD",
    "UPDATE",
    "CREATE",
    "DELETE",
];
export var MERGE_CANDIDATE_LIMIT = 50;
export var MAX_MERGE_SET_SIZE = 10;
export var MIN_MERGE_SET_SIZE = 2;
export var isAgencyTitle = function (source) { return source === "AGENCY"; };
